import type {
  ClientResponse,
  RequestPayload,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/post-patch-request-by-id'
import {
  handleFailure,
  handleSuccess,
  moduleName,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/post-patch-request-by-id'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'

import { handlePatchSuccessSaga } from './sagas/handle-patch-success.saga'

const args: RequestArgs<ServerResponse, ClientResponse, never, RequestPayload> = {
  url: '', // Override when using eg: formatEndpoint(endpoints.api.v4.requestById, { id: requestId })
  method: 'PATCH', // Override to POST if needed
  handleSuccess,
  handleFailure,
}

const patchRequestModule = () =>
  createReduxServiceModule<ServerResponse, ClientResponse, never, RequestPayload>({
    moduleName,
    args,
    sagas: {
      onRequestSuccessSaga: handlePatchSuccessSaga,
    },
  })

export default patchRequestModule
